import queryString from 'query-string';

export default (obj: { [key: string]: any }): string => (
  queryString.stringify(obj, { arrayFormat: 'comma' })
);
